import { render } from "./RequestTrainingModal.vue?vue&type=template&id=386b5a40"
import script from "./RequestTrainingModal.vue?vue&type=script&lang=js"
export * from "./RequestTrainingModal.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Mudassir\\Retrocausal\\portal_frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__